/* eslint-disable no-undef */

const DEFAULT_TIMEOUT = 5;
const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "50px 0px",
  threshold: 0,
};

function binder(methods, object) {
  methods.forEach((method) => {
    object[method] = object[method].bind(object);
  });
}

function Store(target) {
  const self = this;

  self.figure = target.querySelector("figure");
  self.labels = target.querySelectorAll("label[rel]");
  self.radios = [].slice.call(target.querySelectorAll("[type=radio]"));
}

function Autoplay(target) {
  const self = this;

  self.target = target;
  self.timeout =
    (parseInt(target.dataset.autoplay, 10) || DEFAULT_TIMEOUT) * 1e3;
  binder(["scroll", "toggle"], self);

  target.addEventListener("mouseout", self.start);
  target.addEventListener("mouseover", self.stop);
}

Object.assign(Autoplay.prototype, {
  scroll: function scroll() {
    const { radios } = this.target.store;
    const current = radios.findIndex((radio) => radio.checked);
    const next = current === radios.length - 1 ? 0 : current + 1;

    radios[next].checked = true;
    radios[next].dispatchEvent(new Event("change", { bubbles: true }));
  },
  start: function start(e) {
    const { autoplay: self } = e.target.closest("section");

    self.interval = window.setInterval(self.scroll, self.timeout);
  },
  stop: function stop(e) {
    const { autoplay: self } = e.target.closest("section");

    window.clearInterval(self.interval);
    delete self.interval;
  },
  toggle: function toggle() {
    const event =
      document.visibilityState === "hidden" ? "mouseover" : "mouseout";

    this.target.dispatchEvent(new Event(event));
  },
});

function Navigation(target) {
  const self = this;

  self.target = target;
  binder(["navigate", "setHtmlFor", "setLabels"], self);

  self.setLabels(target.store.radios.findIndex((radio) => radio.checked));
  target.addEventListener("change", self.navigate);
}

Object.assign(Navigation.prototype, {
  navigate: function navigate(e) {
    const { setLabels, target } = this;
    const { figure } = target.store;
    const index = parseInt(e.target.id.split("-").pop(), 10);

    setLabels(index);
    figure.style.marginLeft = `${index * -100}%`;
  },
  setHtmlFor: function setHtmlFor(selectedIndex) {
    const { labels, radios } = this.target.store;

    if (labels.length) {
      const nextIndex =
        selectedIndex === radios.length - 1 ? 0 : selectedIndex + 1;
      const prevIndex =
        selectedIndex === 0 ? radios.length - 1 : selectedIndex - 1;

      labels[0].htmlFor = radios[prevIndex].id;
      labels[1].htmlFor = radios[nextIndex].id;
    }
  },
  setLabels: function setLabels(selectedIndex) {
    const { setHtmlFor, target } = this;
    const { labels } = target.store;

    if (labels.length) {
      setHtmlFor(selectedIndex);
    }
  },
});

function process(target) {
  target.store = new Store(target);
  target.navigation = new Navigation(target);
  if (target.hasAttribute("data-autoplay")) {
    target.autoplay = new Autoplay(target);
    if (document.visibilityState !== "hidden") {
      // start autoplay if document visible
      target.autoplay.start({ target });
    }

    document.addEventListener("visibilitychange", target.navigation.toggle);
  }
}

function onIntersection(entries, observer) {
  const intersection = entries.find((entry) => entry.isIntersecting);

  if (intersection) {
    const { target } = intersection;

    process(target);
    observer.unobserve(target);
  }
}

function carouselise() {
  const carousels = document.querySelectorAll("[data-component=carousel-box]");

  if (carousels.length) {
    const intersectionObserver = new IntersectionObserver(
      onIntersection,
      OBSERVER_OPTIONS,
    );

    carousels.forEach((carousel) => {
      intersectionObserver.observe(carousel);
    });
  }
}

export { carouselise };
